/**
 * Keyword and regex helper functions for rule conditions.
 */
/**
 * Escapes special regex characters in a string
 */
export function escapeRegex(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
/**
 * Extracts keywords from a regex pattern by stripping all regex metacharacters.
 */
export function extractKeywordFromRegex(value) {
    return value
        .replace(/\(\?<?!?\[[^\]]*\]\)/g, ' ')
        .replace(/\\[bBdDwWsStnr]|\[\^?\]?[^\]]*\]|[.*+?^${}()|\\]/g, ' ')
        .split(/\s+/)
        .filter(Boolean)
        .join(' ');
}
/**
 * Converts a plain keyword to a regex pattern based on match type
 */
export function keywordToRegexPattern(keyword, matchType = 'exact') {
    const escapedKeyword = escapeRegex(keyword.trim());
    if (matchType === 'exact') {
        return `(?<![a-zA-Z0-9])${escapedKeyword.toLowerCase()}(?![a-zA-Z0-9])`;
    }
    else if (matchType === 'smart') {
        return escapedKeyword.toLowerCase().split(/\s+/).join('.*');
    }
    else {
        const words = escapedKeyword.toLowerCase().split(/\s+/);
        const patterns = words.map((word) => `.*${word}.*`).join('|');
        return `(${patterns})`;
    }
}
/**
 * Checks if a condition is a description match condition
 */
export function isDescriptionCondition(condition) {
    const isDescriptionField = condition.field === '$.description' || condition.field === 'description';
    const isMatchOperator = condition.operator === 'matches' || condition.operator === 'contains';
    return isDescriptionField && isMatchOperator;
}
/**
 * Finds a description condition from an array of AI conditions
 */
export function findDescriptionCondition(conditions) {
    return conditions.find(isDescriptionCondition);
}
/**
 * Extracts keyword from AI response conditions
 */
export function extractKeywordFromConditions(conditions) {
    const descriptionCondition = findDescriptionCondition(conditions);
    if (!descriptionCondition) {
        return undefined;
    }
    const value = descriptionCondition.value.toString();
    if (descriptionCondition.operator === 'matches') {
        return extractKeywordFromRegex(value);
    }
    return value;
}
/**
 * Updates a condition with a new keyword value
 */
export function updateConditionWithKeyword(condition, keyword, matchType = 'exact') {
    const newValue = condition.operator === 'matches'
        ? keywordToRegexPattern(keyword, matchType)
        : keyword;
    return {
        ...condition,
        value: newValue,
    };
}
